import { CircleHelp } from "lucide-react";
import { useState, type ReactElement } from "react";

/**
 * Player keyboard shortcuts reference
 * Displays as a hover tooltip in the style of KeyboardNavigationIndicator
 */

const SHORTCUTS: ReadonlyArray<{ combo: string; desc: string }> = [
  { combo: "Space", desc: "Play / Pause" },
  { combo: "←", desc: "Seek backward 5s" },
  { combo: "→", desc: "Seek forward 5s" },
  { combo: "Shift + ←", desc: "Seek backward 10s" },
  { combo: "Shift + →", desc: "Seek forward 10s" },
  { combo: "F", desc: "Toggle Fullscreen" },
  { combo: "C", desc: "Toggle Captions" },
  { combo: "Esc", desc: "Go Back" },
];

export function ShortcutsHUD(): ReactElement {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-white/10 transition-colors"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        aria-label="Keyboard shortcuts"
      >
        <CircleHelp size={16} className="text-white/80" />
      </button>

      {/* Tooltip with shortcuts */}
      {showTooltip && (
        <div className="absolute top-full right-0 mt-2 w-56 bg-neutral-900/98 backdrop-blur-md border border-neutral-700 rounded-lg shadow-2xl p-3 animate-in fade-in slide-in-from-top-2 duration-200 z-50">
          <div className="text-xs font-semibold text-lumi-accent mb-2">Keyboard Shortcuts</div>
          <div className="space-y-1.5 text-xs text-neutral-300">
            {SHORTCUTS.map((shortcut) => (
              <div key={shortcut.combo} className="flex items-center justify-between">
                <span>{shortcut.desc}</span>
                <kbd className="px-1.5 py-0.5 bg-neutral-800 border border-neutral-700 rounded text-[10px] font-mono">
                  {shortcut.combo}
                </kbd>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
